/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Empty_DescInputs */

const en_fw_bm_empty_desc = /** @type {(inputs: Fw_Bm_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The benchmark opens once at least 5 verified tasks have been recorded. Run tasks through the CLI and your evidence joins the sample — anonymously.`)
};

const id_fw_bm_empty_desc = /** @type {(inputs: Fw_Bm_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benchmark terbuka setelah minimal 5 task terverifikasi tercatat. Jalankan task lewat CLI dan buktimu ikut masuk sampel — secara anonim.`)
};

/**
* | output |
* | --- |
* | "The benchmark opens once at least 5 verified tasks have been recorded. Run tasks through the CLI and your evidence joins the sample — anonymously." |
*
* @param {Fw_Bm_Empty_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_empty_desc = /** @type {((inputs?: Fw_Bm_Empty_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Empty_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_empty_desc(inputs)
	return en_fw_bm_empty_desc(inputs)
});